import { Controller } from "@hotwired/stimulus"
import { track as _track } from '../../heap'

export default class extends Controller {
  track({ params: { id, eventName } }) {
    _track({ id, eventName });
  }
}
